import React, { useState, useEffect, useRef } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { Nav } from 'react-bootstrap';

import SEO from '@/components/common/SEO';

import './AdminDashboard.css';

const NAV_TABS = [
    {
        to: '/admin/overview',
        label: 'Overview',
        icon: 'bi-bar-chart-line',
    },
    {
        to: '/admin/users',
        label: 'User Management',
        icon: 'bi-people',
    },
    {
        to: '/admin/data-sources',
        label: 'Data Sources',
        icon: 'bi-database',
    },
    {
        to: '/admin/communities',
        label: 'Communities',
        icon: 'bi-people',
    },
    {
        to: '/admin/moderation',
        label: 'Moderation',
        icon: 'bi-flag',
    },
];

export default function AdminDashboard() {
    const location = useLocation();
    const navRef = useRef(null);
    const [showScrollHint, setShowScrollHint] = useState(false);

    useEffect(() => {
        const el = navRef.current;
        if (!el) return;

        const check = () => {
            setShowScrollHint(
                el.scrollLeft + el.clientWidth < el.scrollWidth - 4
            );
        };

        check();
        el.addEventListener('scroll', check);
        window.addEventListener('resize', check);
        return () => {
            el.removeEventListener('scroll', check);
            window.removeEventListener('resize', check);
        };
    }, []);

    return (
        <section id="admin-dashboard" className="page-container">
            <SEO title="Admin Dashboard" />
            {/* White header with title and tab nav */}
            <div className="bg-white border-bottom">
                <div className="d-flex justify-content-center align-items-center gap-3 pt-3 pb-2">
                    <i
                        className="bi bi-shield-shaded text-primary fs-2"
                        aria-hidden="true"
                    />
                    <div className="text-center">
                        <h1 className="fs-5 fw-bold mb-0">Admin Dashboard</h1>
                        <p className="admin-header-subtitle small mb-0">
                            Sustainability Hub
                        </p>
                    </div>
                </div>

                <div className="admin-nav-wrapper">
                    <Nav
                        ref={navRef}
                        variant="underline"
                        className="admin-nav justify-content-md-center px-2 px-md-3 gap-2 gap-md-4 mt-2"
                    >
                        {NAV_TABS.map(({ to, label, icon }) => (
                            <Nav.Item key={label}>
                                <Nav.Link
                                    as={Link}
                                    to={to}
                                    active={location.pathname.startsWith(to)}
                                    className="d-flex align-items-center gap-2"
                                >
                                    <i
                                        className={`bi ${icon}`}
                                        aria-hidden="true"
                                    />
                                    {label}
                                </Nav.Link>
                            </Nav.Item>
                        ))}
                    </Nav>
                    <span
                        className={`admin-nav-scroll-hint bg-primary rounded-circle d-md-none${showScrollHint ? '' : ' opacity-0'}`}
                        aria-hidden="true"
                    >
                        <i className="bi bi-arrow-right text-white" />
                    </span>
                </div>
            </div>

            {/* Dark green content area */}
            <div className="flex-grow-1 overflow-auto bg-primary py-3 py-md-5">
                <Outlet />
            </div>
        </section>
    );
}
